/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../styles/components/common/MobileModal.module.css';

const MobileModal: React.FC<{
	open: boolean;
	onClose: () => void;
	children: React.ReactNode;
}> = ({ open, onClose, children }) => {
	if (!open) return null;

	return (
		<div className={styles.overlay} onClick={onClose}>
			<div className={styles.modal} onClick={e => e.stopPropagation()}>
				{children}
			</div>
		</div>
	);
};

export default MobileModal;
